export default __webpack_public_path__ + "static/media/icon_listview_24_Regular.65b76982.svg";